import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import MessageArea from '@ui-parts/MessageArea';
import LinkButton from '@ui-parts/LinkButton';
import { PALETTE } from '~/assets/styles/base';
import { ROUTES } from '~/constants/routes';

const MessageAreaWrapper = styled.div`
  max-width: 432px;
  height: 351px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 71px auto 0;
  background-color: ${PALETTE.white};
  // MessageArea内のスタイル調整
  svg + p {
    margin: 22px 0 10px;
    color: ${PALETTE.text.primary};
  }
  button {
    min-width: 156px;
  }
`;

const StyledTaskAltIcon = styled(TaskAltIcon)`
  color: ${PALETTE.text.primary};
  font-size: 4.8rem;
  margin-top: 6px;
`;

const AdminVerifyCompleted = () => {
  const { t } = useTranslation();

  return (
    <MessageAreaWrapper>
      <MessageArea
        message={t('adminMessage.register.message')}
        desc={t('adminMessage.register.desc')}
        button={
          <LinkButton
            label={t('adminMessage.register.link')}
            variant="outlined"
            href={ROUTES.ADMIN.MYPAGE}
          />
        }
      >
        <StyledTaskAltIcon />
      </MessageArea>
    </MessageAreaWrapper>
  );
};

export default AdminVerifyCompleted;
